import React from "react";
import { Link, RouteComponentProps } from "react-router-dom";

import { DateTime } from "luxon";

import { apiGet } from "../../Api";
import { formatDateLocal, formatName } from "../../Utilities";
import withTitle from "../withTitle";

import "../../schedule.css";
import "../viewer.css";
import ViewToolbar from "../ViewToolbar";
import HasRight from "../HasRight";

interface IQuestionnaireAppointmentsViewState {
    searchResults?: { [date: string]: any[] };
    isLoading: boolean;
    error?: string;
}

class QuestionnaireAppointmentsView extends React.Component<RouteComponentProps<any>, IQuestionnaireAppointmentsViewState> {
    constructor(props: Readonly<RouteComponentProps<any>>) {
        super(props);

        this.state = {
            isLoading: false,
        };

        this.loadData = this.loadData.bind(this);
    }

    public componentDidMount() {
        this.loadData();
    }

    public render() {
        let results;

        if (this.state.isLoading) {
            results = <div className="lds-dual-ring spinner-center" />;
        }
        else if (this.state.error) {
            results = <span className="error-text">{this.state.error}</span>;
        }
        else if (this.state.searchResults && Object.keys(this.state.searchResults).length === 0) {
            results = <span>No appointments found</span>;
        }
        else if (this.state.searchResults) {
            results = (
                <section className="info-block">
                    <header>
                        <h3>Appointments</h3>
                    </header>
                    {
                        Object.keys(this.state.searchResults).map(k => (
                            <section key={k} className="schedule-section">
                                <h3>{formatDateLocal(k)}</h3>
                                <ul>
                                    {
                                        this.state.searchResults![k].map(r => (
                                            <li key={r.id} className={this.statusToClass(r.status)}>
                                                <Link to={`/appointments/${r.id}`}>
                                                    <span>{formatName(r.patient.name)}</span>
                                                    <span className="small-text">{r.appointmentType.name} &mdash; {r.location.name}</span>
                                                </Link>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </section>
                        ))
                    }
                </section>
            );
        }

        return (
            <div className="viewer-root">
                <ViewToolbar>
                    <HasRight right="appt:create">
                        <Link to={{ pathname: "/appointments/create", state: { surveyId: this.props.match.params.id } }} className="icon-plus" />
                    </HasRight>
                </ViewToolbar>
                {results}
            </div>
        );
    }

    private async loadData() {
        this.setState({
            isLoading: true,
        })

        try {
            const results = await apiGet<any[]>(`survey/${this.props.match.params.id}/appointments`);

            const groups: { [time: string]: any[] } = {};
            results.forEach(r => {
                const date = DateTime.fromISO(r.appointmentTimestamp);
                const dateString = date.toISODate();
                if (!groups[dateString]) {
                    groups[dateString] = [];
                }

                groups[dateString].push(r);
            });

            this.setState({
                error: undefined,
                isLoading: false,
                searchResults: groups
            });
        } catch (e) {
            this.setState({
                error: e.message,
                isLoading: false
            });
        }
    }

    private statusToClass(status: number) {
        switch (status) {
            case 0: return "";
            case 1: return "";
            case 5: return "";

            case 2: return "appt-bad";
            case 3: return "appt-noshow";
            case 4: return "appt-good";
            default: return "";
        }
    }
}

export default withTitle("Questionnaire Appointments", QuestionnaireAppointmentsView);
